import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import CurrencySelector from '../../../components/CurrencySelector';
import Select from 'react-select';
import DatePicker from '../../../components/DatePicker/index';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import { Validate, ErrorMessage } from '../../../../../components/Validation';

export class DescriptionOfItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  onChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regexNumber = /^(0*[1-9]\d*(\.\d{0,2})?|0+\.\d*[1-9]\d*)$/; // regex to check for number > 0
    let value = target.type === 'checkbox' ? target.checked : target.value;
    if (regexNumber.test(value)) {
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    } else {
      value = '';
      const item = { ...this.props.item, ...{ [propertyName]: value } };
      this.change(item);
    }
  };

  onChangeResetReceived = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    item.fromWhom = '';
    item.howMuch = '';
    item.currencyExpensesClaimed = '';
    item.dateReimbursementReceived = '';
    this.change(item);
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };

  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  handleChangeInsureds = (selectedClaimFor) => {
    if (selectedClaimFor) {
      const item = { ...this.props.item, ...{['selectedClaimFor']: selectedClaimFor } };
      this.change(item);
    }
  };

  render() {
    const { item } = this.props;
    const {
      disabled,
      removable,
      validatorGroup,
      validationCounter,
      insuredsList,
      isAppsureInstanceSCTI,
    } = this.props;
    const selectedClaimForList = !!item.selectedClaimFor && typeof item.selectedClaimFor.toJS === 'function'
    ? item.selectedClaimFor.toJS()
    : item.selectedClaimFor || [];

    return (
      <div className="expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="form-group col-auto">
            <PageSectionHeader>
              <FormattedMessage {...messages.itemWithIdx} values={{ idx: this.props.index + 1 }} />
            </PageSectionHeader>
          </div>
        </div>
        {isAppsureInstanceSCTI === true &&
          <div className="row">
            <div className="form-group col-sm-7 col-md-7">
              <Validate
                name="claimFor"
                validators={[required]}
                group={validatorGroup}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                defaultValue={selectedClaimForList}
                fieldName={messages.expenseFor}
                tooltipContent={messages.expenseFor}
                tooltipDataFor={'claimForHint'}
              >
                <Select
                  name="claimFor"
                  isMulti
                  isDisabled={disabled}
                  options={insuredsList}
                  placeholder="Select Insured(s)"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  onChange={(v) => {
                    this.handleChangeInsureds(v);
                  }}
                  value={selectedClaimForList}
                  getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                  getOptionValue={(option) => option.id}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.expenseFor}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className="form-group col-sm-5 col-md-5">
            </div>
          </div>
        }
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.nameOfProvider}
              fieldName={messages.nameOfProvider}
            >
              <Textbox
                disabled={disabled}
                name="item"
                type="text"
                onChange={this.onChange('nameOfProvider')}
                value={item.nameOfProvider}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.nameOfProvider}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
                <Validate
                  name="dateIncurred"
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required, checkDateOnly]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  defaultValue={item.dateIncurred}
                  fieldName={messages.dateIncurred}
                >
                  <DatePicker
                    disabled={disabled}
                    name="dateIncurred"
                    type="text"
                    onDayChange={this.handleDayChange('dateIncurred')}
                    value={item.dateIncurred}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateIncurred}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateIncurred}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.amountClaimed}
              fieldName={messages.amountClaimed}
            >
              <Textbox
                disabled={disabled}
                name="amountClaimed"
                type="number"
                onChange={this.onChangeAmount('amountClaimed')}
                value={item.amountClaimed}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.amountClaimed}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.currencyExpensesClaimed}
              fieldName={messages.currency}
            >
              <CurrencySelector
                onChange={this.handleCurrencyChange('currencyExpensesClaimed')}
                disabled={disabled}
                value={item.currencyExpensesClaimed}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.currency}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-7 col-md-7">
            <PageSectionHeader>
              <FormattedMessage {...messages.amountPaidByOtherInsurance} />
            </PageSectionHeader>
            <Textbox
              disabled={disabled}
              name="amountPaidByOtherInsurance"
              type="number"
              onChange={this.onChangeAmount('amountPaidByOtherInsurance')}
              value={item.amountPaidByOtherInsurance}
            />
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <PageSectionHeader>
              <FormattedMessage {...messages.currency} />
            </PageSectionHeader>
            <CurrencySelector
              onChange={this.handleCurrencyChange('currencyAmountPaid')}
              disabled={disabled}
              value={item.currencyAmountPaid}
            />
          </div>
        </div>
      </div>
    );
  }
}

DescriptionOfItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
  insuredsList: PropTypes.any,
  isAppsureInstanceSCTI: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.MedicalExpense/components/DescriptionOfItem/DescriptionOfItem.js